import { computed, reactive } from "vue";

import { listBrands } from "../api/brands.js";
import { session } from "./session.js";

export const brandState = reactive({ loading: false, error: "", items: [], currentId: null });
export const brandFlow = reactive({ active: false, name: "" });
export const currentBrand = computed(() => brandState.items.find((brand) => String(brand.id) === String(brandState.currentId)) || null);

let pending;

function storageKey() {
  return `soa_cb_${session.user?.id || session.user?.email || "user"}`;
}

export async function loadBrands({ signal } = {}) {
  if (pending) return pending;
  brandState.loading = true;
  brandState.error = "";
  pending = listBrands({ signal })
    .then((data) => {
      brandState.items = data.brands || [];
      let saved = null;
      try { saved = localStorage.getItem(storageKey()); } catch { /* Storage is optional. */ }
      const selected = brandState.items.find((brand) => String(brand.id) === String(brandState.currentId || saved));
      brandState.currentId = (selected || brandState.items[0])?.id || null;
      return brandState.items;
    })
    .catch((error) => {
      brandState.error = error.message || "Brands are unavailable.";
      throw error;
    })
    .finally(() => { brandState.loading = false; pending = null; });
  return pending;
}

export function selectBrand(brandId) {
  const selected = brandState.items.find((brand) => String(brand.id) === String(brandId));
  if (!selected) return false;
  brandState.currentId = selected.id;
  try { localStorage.setItem(storageKey(), String(selected.id)); } catch { /* Storage is optional. */ }
  return true;
}

// Pre-Vue parity (selectGlobalBrandByName): pick the brand whose name matches; a not-yet-registered
// name (a scan just launched) clears the selection instead of snapping back to the first brand.
export function selectBrandByName(name, opts = {}) {
  const match = findBrandByName(name);
  if (match) { selectBrand(match.id); return true; }
  if (!opts.keepCurrent) brandState.currentId = null;
  return false;
}

export function findBrandByName(name) {
  const key = String(name || "").trim().toLowerCase();
  if (!key) return null;
  return brandState.items.find((brand) => String(brand.brand || "").trim().toLowerCase() === key) || null;
}

export function setBrandFlow(active, name = "") {
  brandFlow.active = Boolean(active);
  brandFlow.name = brandFlow.active ? String(name || "").trim() : "";
}
